/* unplugin-vue-components disabled */import { render } from "./down-button.vue?vue&type=template&id=0a6112ac&scoped=true"
import script from "./down-button.vue?vue&type=script&lang=js"
export * from "./down-button.vue?vue&type=script&lang=js"

import "./down-button.vue?vue&type=style&index=0&id=0a6112ac&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6112ac"],['__file',"src/components/ai-chat-v2/down-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a6112ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a6112ac', __exports__)) {
    api.reload('0a6112ac', __exports__)
  }
  
  module.hot.accept("./down-button.vue?vue&type=template&id=0a6112ac&scoped=true", () => {
    api.rerender('0a6112ac', render)
  })

}


export default __exports__